import script from "./CallbackView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallbackView.vue?vue&type=script&setup=true&lang=ts"

import "./CallbackView.vue?vue&type=style&index=0&id=2d6561a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6561a4"]])

export default __exports__